import { render, staticRenderFns } from "./ClassificationField.vue?vue&type=template&id=6a6b8b6e"
import script from "./ClassificationField.vue?vue&type=script&lang=js"
export * from "./ClassificationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports